module.exports = __webpack_public_path__ + "media/images/logo-ef056847.png";